export const CONTRACTS: {[key: string]: any} = {
  datum: {
    TESTNET_ADDRESS: '0xE2b809D47C91dB45906dA739fdAE868e556Dd56F',
    MAINNET_ADDRESS: '0x0000000000000000000000000000706c61736d61'
  },
  mainnet: {
    DATUM_ADDRESS: '0x81c9151de0c8bafcd325a57e3db5a5df1cebf79c',
    PLASMA_ADDRESS: '0xFff7AAD0bf6D660574C0Ca348b84C1f362989b3C',
  },
  rinkeby: {
    DATUM_ADDRESS: '0x3abf7c0b6886cb9cc12b3c620d1d06910325e3be',
    PLASMA_ADDRESS: '0xa9761290469586Ee5Ba6ED820059f1e28e6aefB5',
  },
};

export * from './contracts';
